import dynamic from "next/dynamic";
import GlobeErrorBoundary from "@/components/GlobeErrorBoundary";

const Globe = dynamic(
  () => import("@/components/GlobeVisualization"),
  {
    ssr: false,
    loading: () => (
      <div className="absolute inset-0 flex items-center justify-center bg-black">
        <div className="flex flex-col items-center gap-4">
          {/* Pulsing globe placeholder */}
          <div className="relative w-32 h-32">
            <div
              className="absolute inset-0 rounded-full animate-pulse"
              style={{
                background:
                  "radial-gradient(circle at 35% 35%, #0a1628 0%, #062056 50%, #020814 100%)",
                boxShadow: "0 0 60px rgba(0,212,255,0.08)",
              }}
            />
            <div
              className="absolute -inset-4 rounded-full"
              style={{
                background:
                  "radial-gradient(circle, rgba(0,212,255,0.06) 40%, transparent 70%)",
              }}
            />
          </div>
          <p className="text-[13px] text-[#71717A] font-[family-name:var(--font-geist-mono)]">
            Loading globe...
          </p>
        </div>
      </div>
    ),
  }
);

export default function DynamicGlobe() {
  return (
    <GlobeErrorBoundary>
      <Globe />
    </GlobeErrorBoundary>
  );
}
